import { useEffect, useState } from 'react';
import DialogInfoGeneral from './DialogInfoGeneral';
import { FiWifiOff } from 'react-icons/fi';
import { GrWifi } from 'react-icons/gr';
import { HiWifi } from 'react-icons/hi';

const OfflineAlert = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (

    <div>
      {!isOnline && (
          <DialogInfoGeneral
            show={true} 
            closeDialog={() => null}
            disabledClosable={false}
            disabledFooter={true}
           >
            <div className='text-center py-4 px-4 '>
              <div className='text-lg'>
                <div className='pt-2 font-medium'>
                Sin Conexión a Internet
                </div>
                <div className="flex justify-center py-4">
                  <FiWifiOff size={50} className='text-red-500 floating' />
                </div>
                <div className='py-4 mt-2 opensans font-normal text-lg'>
                En este momento, no tienes una conexión a internet.
                </div>

                <div className='py-2 font-light'>
                El sitio volverá a la normalidad en cuanto recuperes tu conexión a internet.
                  <div className="flex justify-center py-4">
                    <HiWifi size={50} className='text-green-300 floating' />
                  </div>
                </div>
              </div>
            </div>
          </DialogInfoGeneral>
      )}
    </div>
  );
};
 
export default OfflineAlert;
